<template>
    <div>
      <!-- Floating Button -->
      <div 
        v-if="!isOpen"
        class="whatsapp-widget"
        :class="{ 'widget-hidden': !isVisible }"
        @click="toggleWidget"
      >
        <div class="whatsapp-bubble">
            <svg 
                viewBox="0 0 24 24" 
                width="28" 
                height="28" 
                fill="white"
            >
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
            </svg>
        </div>
      </div>
  
      <!-- Chat Widget -->
      <transition name="slide-up">
        <div v-if="isOpen" class="whatsapp-chat-widget">
          <div class="chat-header">
            <div class="header-content">
              <div class="avatar">
                <svg class="whatsapp-icon" viewBox="0 0 24 24" width="24" height="24">
                  <path fill="#fff" d="M12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-5.46-4.45-9.91-9.91-9.91"/>
                </svg>
              </div>
              <div class="header-info">
                <h3>Chat with us</h3>
                <p>Typically replies within minutes</p>
              </div>
            </div>
            <button class="close-btn" @click="toggleWidget">×</button>
          </div>
  
          <div class="chat-body">
            <div class="welcome-message">
              <p>Hello! 👋</p>
              <p>How can we help you today?</p>
            </div>
  
            <div class="quick-questions">
              <button 
                v-for="(question, index) in quickQuestions"
                :key="index"
                class="quick-question"
                @click="sendQuickQuestion(question)"
              >
                {{ question }}
              </button>
            </div>
  
            <div class="custom-message">
              <textarea
                v-model="customMessage"
                placeholder="Type your message here..."
                rows="3"
                @keyup.enter="sendCustomMessage"
              ></textarea>
              <button 
                class="send-btn"
                :disabled="!customMessage.trim()"
                @click="sendCustomMessage"
              >
                Send
              </button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </template>
  
  <script>
  export default {
    name: 'WhatsAppWidget',
    data() {
      return {
        isOpen: false,
        isVisible: false,
        customMessage: '',
        quickQuestions: [
          'How do I enroll for a course?',
          'Can I get a free course?',
          'What are your working hours?'
        ],
        phoneNumber: '2349073016297'
      }
    },
    mounted() {
      // Show widget after 5 seconds
      setTimeout(() => {
        this.isVisible = true;
      }, 1000);
  
      // Auto-open after 10 seconds
      setTimeout(() => {
        if (!this.isOpen) {
          this.isOpen = true;
        }
      }, 10000);
    },
    methods: {
      toggleWidget() {
        this.isOpen = !this.isOpen;
      },
      sendQuickQuestion(question) {
        this.openWhatsApp(question);
      },
      sendCustomMessage() {
        if (this.customMessage.trim()) {
          this.openWhatsApp(this.customMessage);
          this.customMessage = '';
        }
      },
      openWhatsApp(message) {
        const encodedMessage = encodeURIComponent(message);
        const url = `https://wa.me/${this.phoneNumber}?text=${encodedMessage}`;
        window.open(url, '_blank');
        this.isOpen = false;
      }
    }
  }
  </script>
  
  <style scoped>
  .whatsapp-widget {
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 1000;
    transition: transform 0.3s ease;
  }
  
  .whatsapp-widget.widget-hidden {
    transform: translateY(100px);
    opacity: 0;
  }
  
  .whatsapp-bubble {
    width: 60px;
    height: 60px;
    background-color: #25D366;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
  }
  
  .whatsapp-bubble:hover {
    background-color: #128C7E;
    transform: scale(1.1);
  }
  
  .whatsapp-chat-widget {
    position: fixed;
    bottom: 90px;
    right: 20px;
    width: 350px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
    z-index: 1001;
    overflow: hidden;
  }
  
  .chat-header {
    background: #000080; 
    color: white;
    padding: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .header-content {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .avatar {
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .header-info h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    color: #ffffff;
  }
  
  .header-info p {
    margin: 4px 0 0;
    font-size: 12px;
    opacity: 0.9;
  }
  
  .close-btn {
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
    padding: 0;
    width: 24px;
    height: 24px;
    line-height: 1;
  }
  
  .chat-body {
    padding: 20px;
  }
  
  .welcome-message {
    background: #f0f9ff;
    padding: 16px;
    border-radius: 12px;
    margin-bottom: 20px;
  }
  
  .welcome-message p {
    margin: 0 0 8px;
  }
  
  .welcome-message p:last-child {
    margin-bottom: 0;
  }
  
  .quick-questions {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-bottom: 20px;
  }
  
  .quick-question {
    background: #f5f5f5;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    padding: 12px;
    text-align: left;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
  }
  
  .quick-question:hover {
    background: #e8f5e8;
    border-color: #25D366;
  }
  
  .custom-message textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    resize: none;
    font-family: inherit;
    font-size: 14px;
    margin-bottom: 10px;
  }
  
  .custom-message textarea:focus {
    outline: none;
    border-color: #25D366;
  }
  
  .send-btn {
    width: 100%;
    background: #25D366;
    color: white;
    border: none;
    border-radius: 8px;
    padding: 12px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.3s ease;
  }
  
  .send-btn:hover:not(:disabled) {
    background: #128C7E;
  }
  
  .send-btn:disabled {
    background: #cccccc;
    cursor: not-allowed;
  }
  
  /* Animation */
  .slide-up-enter-active,
  .slide-up-leave-active {
    transition: all 0.3s ease;
  }
  
  .slide-up-enter-from,
  .slide-up-leave-to {
    opacity: 0;
    transform: translateY(20px);
  }
  </style>